import { AggregatedSummedProjectOrders } from '~/common/api/orderingServiceApi/OrderingApi';
import { CollapseButton } from '~/common/components/defaultUIComponents/CollapseButton';
import { LabeledText } from '~/common/components/defaultUIComponents/LabeledText';
import { Collapse, Divider, Grid, GridItem, Stack } from '@chakra-ui/react';
import { OrderedProjectSummary } from '../common/OrderedProjectSummary';
import { Link } from '~/common/components/defaultUIComponents/Link';
import { OrderedProjectsContext } from './OrderedProjectsContext';
import routes from '~/common/constants/routes.json';
import { Paper } from '~/common/components/Paper';
import { BellIcon } from '@chakra-ui/icons';
import { useStore } from 'zustand';
import { useContext } from 'react';

function allCheckedIn(orderedProject: AggregatedSummedProjectOrders) {
  return orderedProject.orderedProjects.some(
    (op) => op.doneAmount > 0 && !op.checkedIn,
  );
}

export function OrderedProjectEntry(props: {
  orderedProject: AggregatedSummedProjectOrders;
}) {
  const { openProject, setOpenProject } = useStore(
    useContext(OrderedProjectsContext),
  );
  const project = props.orderedProject.project;
  const isOpen = openProject === project.id;
  const orderedProjects = props.orderedProject.orderedProjects;

  return (
    <Paper>
      <Stack>
        <Grid templateColumns="repeat(6, 1fr)" columnGap={5}>
          <GridItem colSpan={2} mt={1}>
            <Link
              mr={1}
              href={routes.PROJECT.replace(':id', project.id.toString())}
              fontSize={20}
              textDecoration="underline"
              fontWeight="semibold"
              onClick={() => setOpenProject(project.id)}
            >
              {project.name}
            </Link>
          </GridItem>
          <GridItem colSpan={3}>
            <LabeledText label="ordertileHeader.orderProject.amount.text">
              {props.orderedProject.totalAmount}
            </LabeledText>
          </GridItem>
          <GridItem display="flex" justifyContent="flex-end">
            {allCheckedIn(props.orderedProject) && (
              <BellIcon ml={2} h={10} w={10} color="red.600" />
            )}
            <CollapseButton
              isOpen={isOpen}
              toggleIsOpen={() => setOpenProject(project.id)}
              ml={3}
            />
          </GridItem>
        </Grid>
        <Collapse in={isOpen}>
          {isOpen && (
            <>
              <Divider borderColor="gray" />
              {orderedProjects.map((orderedProject) => (
                <OrderedProjectSummary
                  key={orderedProject.id}
                  orderedProject={orderedProject}
                />
              ))}
            </>
          )}
        </Collapse>
      </Stack>
    </Paper>
  );
}
